import {getSupplierFunction} from "@project/sdk/engineering";
import {GetSupplierFunctionResponse} from "@project/sdk/engineering/zod";
import {queryOptions} from "@tanstack/react-query";

import {queryPolicyDefaults} from "../../../../../shared/query/query-policies";
import {supplierFunctionKeys} from "../../../supplierFunction-keys";

export function getSupplierFunctionQueryOptions(
  supplierFunctionId: string,
  includeDeleted = false,
) {
  return queryOptions({
    ...queryPolicyDefaults.warm,
    staleTime: 0,
    queryKey: [...supplierFunctionKeys.detail(supplierFunctionId), {includeDeleted}] as const,
    queryFn: async ({signal}) =>
      GetSupplierFunctionResponse.parse(
        await getSupplierFunction(supplierFunctionId, {includeDeleted}, {signal}),
      ),
  });
}
